import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import { getOnClickAndOnKeyPressDownEvents } from 'helpers/getOnClickAndOnKeyPressDownEvents'
import Text from 'components/common/Text/Text'
import Icon from 'components/common/Icon/Icon'
import * as UI from '../Common.styles'
import {
  NEXT_DAY_MESSAGE_PREFIX,
  NEXT_DAY_MESSAGE_SUFFIX,
  AVAILABLE_TIME
} from '../constants'
import ScheduleBlock from '../../ScheduleBlock'
import { DROP_OFF_NEXT_DAY_TIME_FIELD_NAME } from 'constant'
import { getFormattedDate } from './../../../helpers'

const NextDayTimeTable = ({
  nextDay,
  splitTimeBlocks = [],
  handleDateTimeSelect,
  handleNextDaySelect,
  time = {},
  isCurrentDateSelected,
  timeSlotsNumber
}) =>
  <Fragment>
    <UI.Separator data-content={ 'or' } />
    <UI.Description block centered margin={ '15px 0 5px' }>
      { `${NEXT_DAY_MESSAGE_PREFIX}`}
      <UI.NextDayCount bold>{timeSlotsNumber}</UI.NextDayCount>
      { `${NEXT_DAY_MESSAGE_SUFFIX}`}
      <Text bold>
        {`${getFormattedDate(nextDay)}`}
      </Text>
    </UI.Description>
    <Media.Desktop>
      <UI.NextDayContainer showOverflow={ timeSlotsNumber < 3 } >
        <UI.Times>
          <UI.CustomColumns width={ '50% 50%' }>
            {
              splitTimeBlocks.map((timeBlocksSplitted, index) =>
                <fieldset key={ index }>
                  <legend data-sr-only>{ AVAILABLE_TIME }</legend>
                  {
                    timeBlocksSplitted.map(({ displayName, value }) =>
                      <ScheduleBlock
                        key={ value }
                        name={ DROP_OFF_NEXT_DAY_TIME_FIELD_NAME }
                        displayName={ displayName }
                        date={ nextDay }
                        value={ value }
                        selected={ isCurrentDateSelected === false && time && time.value === value }
                        onSelect={ handleDateTimeSelect } />
                    )
                  }
                </fieldset>
              )
            }
          </UI.CustomColumns>
        </UI.Times>
      </UI.NextDayContainer>
    </Media.Desktop>
    <Media.Mobile>
      {
        <UI.Drop type="button" link { ...getOnClickAndOnKeyPressDownEvents(handleNextDaySelect) }>
          <Text
            follow_link
            size="18"
            weight="500">SEE NEXT AVAILABLE DAY</Text>
          <Icon
            asset="caret-red-right"
            height="10px"
            margin="0 0 0 5px" />
          <Icon
            asset="caret-red-right"
            height="10px"
            margin="" />
        </UI.Drop>
      }
    </Media.Mobile>
  </Fragment>

NextDayTimeTable.propTypes = {
  currentDate: PropTypes.string,
  dates: PropTypes.shape({}),
  handleDateTimeSelect: PropTypes.func,
  handleNextDaySelect: PropTypes.func,
  handleTimeSelect: PropTypes.func,
  isCheckout: PropTypes.bool,
  isCurrentDateSelected: PropTypes.bool,
  nextDay: PropTypes.string,
  splitTimeBlocks: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape())),
  time: PropTypes.shape({
    displayName: PropTypes.string,
    value: PropTypes.string
  }),
  timeBlocks: PropTypes.arrayOf(PropTypes.shape()),
  timeSlotsNumber: PropTypes.number
}

export default NextDayTimeTable
